import React from 'react';
import Wishlist from 'src/components/Wishlist';
import HotelCardStars from '../HotelCardStars';
import HotelCardLocation from '../HotelCardLocation';
import HotelCardTitle from '../HotelCardTitle/HotelCardTitle';
import styles from './hotelCardTitleBlock.module.css';

type HotelCardTitleBlockProps = {
  stars: number;
  hotelName: string;
  hotelLocation: string;
  hotelPageHref: string;
  openInCurrentTab: boolean;
  price: number;
  id: number;
};

const HotelCardTitleBlock: React.FC<HotelCardTitleBlockProps> = ({
  stars,
  hotelLocation,
  hotelName,
  hotelPageHref,
  openInCurrentTab,
  price,
  id,
}) => (
  <div className={styles.titleBlock}>
    <div>
      <div className={styles.locationContainer}>
        <HotelCardStars value={stars} />
        <HotelCardLocation isMobile={false}>{hotelLocation}</HotelCardLocation>
      </div>
      <HotelCardTitle
        hotelPageHref={hotelPageHref}
        isMobile={false}
        openInCurrentTab={openInCurrentTab}
      >
        {hotelName}
      </HotelCardTitle>
    </div>
    <Wishlist
      type="hotel"
      price={price}
      wishlistIdentifier={id}
      isWhiteHeart={false}
      isHotelCardFromMap={false}
    />
  </div>
);

export default HotelCardTitleBlock;
